module.exports = __webpack_public_path__ + "static/media/image-18.83f03db6.png";